<template>
  <div>

    <Head title="Invoicing Queue" />
    <h1 class="mb-8 text-3xl font-bold">Upload Credit Notes</h1>
    <div class="flex items-center justify-between mb-6">
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto p-6">
      <form @submit.prevent="submit" enctype="multipart/form-data">
        <div class="mb-4">
          <label for="file" class="block text-gray-700 mb-2">Select Excel file:</label>
          <input type="file" id="file" name="file" accept=".xls,.xlsx" @change="handleFileChange" required
            class="block w-full text-gray-700 border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-blue-300" />
        </div>

        <button type="submit" class="btn-orange px-3 py-2 text-xs cursor-pointer rounded-lg transition duration-200">
          Upload
        </button>
      </form>
    </div>
    <div class="flex items-center justify-between mt-5">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset"/>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3 border border-dark">Date</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Credit Note Number</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Invoice Ref No</th>
          <th class="pb-3 pt-3 px-3 border border-dark">PIN</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Total Invoice Amount</th>
          <th class="pb-3 pt-3 px-3 border border-dark">User</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Message</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Action</th>
        </tr>
        <tr v-for="holdCreditNote in holdCreditNotes.data" :key="holdCreditNote.id" class="text-left">
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.created_at }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.trader_system_invoice_number }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.relevant_invoice_number }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.pin_of_buyer }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.total_invoice_amount }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.system_user }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">{{ holdCreditNote.message }}</td>
          <td class="pb-3 pt-3 px-3 border border-dark">
            <span
              class="bg-orange-500 text-white text-sm py-1 px-2 rounded hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300 mr-1 ml-1 cursor-pointer"
              @click="openModal(holdCreditNote)">View</span>
            <span
              class="bg-orange-500 text-white text-sm py-1 px-2 rounded hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300 mr-1 ml-1 cursor-pointer"
              @click="retryValidation(holdCreditNote)"
            >
              Retry
            </span>
          </td>
        </tr>
        <tr v-if="!holdCreditNotes.data.length">
          <td class="px-3 py-3 border-t border border-dark" colspan="7">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="holdCreditNotes.links" />
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div
            class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full"
          >
            <h1>
              {{ creditObj.trader_system_invoice_number }} 
            </h1>
          </div>
          <div v-if="details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size: 20px; font-weight: bold">Credit Note Details</h1>
                </div>
              </div>
            </div>
            <div class="mb-4 overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Tax Rate</th>
                  <th class="pb-3 pt-3 px-3">Quantity</th>
                  <th class="pb-3 pt-3 px-3">Unit Price</th>
                  <th class="pb-3 pt-3 px-3">Discount (%)</th>
                  <th class="pb-3 pt-3 px-3">Measure Unit</th>
                  <th class="pb-3 pt-3 px-3">VAT Class</th>
                </tr>
                <tr v-for="(item, index) in details" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.name_plu }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.tax_rate }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.quantity }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.unit_price }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.discount }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.measure_unit }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.vat_class }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="close"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import SearchFilter from "@/Shared/SearchFilter";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from 'lodash/mapValues'
import Pagination from "@/Shared/Pagination";

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    holdCreditNotes: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        id: null,
      }),
      selectedFile: null,
      search: {
        dateValue: this.filters.dateValue,
        search: this.filters.search,
      },
      isOpen: false,
      details: null,
      creditObj: null,
    };
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role;
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/upload-credit-notes/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    openModal(data) {
      this.isOpen = true;
      this.details = data.details;
      this.creditObj = data;
    },
    close() {
      this.isOpen = false
      this.details = null;
      this.creditObj = null;
    },
    retryValidation(credit) {
      if (confirm(`Are you sure you want to resend this credit note ${credit.trader_system_invoice_number}?`)) {
        this.form.id = credit.id;
        this.form._method = "post";
        this.$inertia.post(`/push-credit-notes/${credit.id}`, this.form, {
          onSuccess: () => {
            this.form.id = null;
          },
        });
      }
    },
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    url() {
      let query = '';
      if (this.search.search) {
        query += `search=${this.search.search}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
      }
    },
    submit() {
      if (this.selectedFile) {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        this.$inertia.post('/push-credit-notes', formData);
      }
    }
  },
};
</script>
<style type="text/css">
.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>